<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <repse-request-table
            :data="data"
            :title="title"
            @loadMore="loadMore"
            @search="search"
            @refresh="search"
            @delete="deleteRequest"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>
    
  <script>
import RepseRequestTable from './components/RepseRequestTable.vue'
import repse from '../requests/repse.js'
import loading from '@/mixins/Loading'

export default {
  components: {
    RepseRequestTable,
  },
  data() {
    return {
      data: [],
      item: {},
      documentation: {
        id: '',
        document_name: '',
        vendor_name: '',
      },
      lastPage: 1,
      loadingPage: 'repse-requests-loading',
      params: {
        search: '',
        page: 1,
      },
      title: '',
    }
  },
  methods: {
    getData: function () {
      this.openLoading(this.loadingPage)
      repse
        .getRequests(this.params, this.documentation.id)
        .then((response) => {
          let data = response.data.data
          if (this.params.page === 1) {
            this.data = [...data]
          } else {
            this.data = [...this.data, ...response.data.data]
          }
          this.lastPage = response.data.last_page
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
    loadMore: function () {
      if (this.params.page < this.params.lastPage) {
            this.params.page++
            this.getData()
      }
    },
    search: function (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    getDetails: function (id) {
      this.openLoading(this.loadingPage)
      repse
        .getDocumentationDetails(id)
        .then((response) => {
          this.documentation = Object.assign({}, response.data.documentation)
          this.title =
            this.documentation.document_name +
            ' - ' +
            this.documentation.vendor_name
          this.closeLoading(this.loadingPage)
          this.getData()
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
    deleteRequest: function (event) {
      const payload = { id: event.request_id }
      console.log(payload)
      this.openLoading(this.loadingPage)
      repse
        .deleteRequest(payload)
        .then((res) => {
          this.getData()
          this.closeLoading(this.loadingPage)
        })
        .catch((res) => {
          this.showValidationErrors(res)
          this.closeLoading(this.loadingPage)
        })
    },
  },
  mixins: [loading],
  mounted: function () {
    let id = this.$route.params.id
    this.getDetails(id)
  },
  watch: {
    isLoading: function (val) {
      if (val) {
        this.openLoading(this.loadingPage)
      } else {
        this.closeLoading(this.loadingPage)
      }
    },
  },
}
</script>
    
    <style>
</style>s